'use client'
import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { Textarea } from '@/common/ui/textarea'
import { Label } from '@/common/ui/label'
import { useMutationCancelSmsAutoLog } from '@/modules/transaction/api/hooks/useMutationCancelSmsAutoLog'

interface CancelDialogProps {
	smsLogId: string
	isOpen: boolean
	onClose: () => void
}

export default function CancelDialog({
	smsLogId,
	isOpen,
	onClose,
}: CancelDialogProps) {
	const [note, setNote] = useState('')
	const { mutate, isPending } = useMutationCancelSmsAutoLog()

	const handleConfirm = () => {
		if (!note.trim()) return
		mutate(
			{ id: smsLogId, data: { note } },
			{
				onSuccess: () => {
					setNote('')
					onClose()
				},
			},
		)
	}

	const handleClose = () => {
		setNote('')
		onClose()
	}

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle>ยกเลิก SMS</DialogTitle>
				</DialogHeader>
				<div className="space-y-4 py-2">
					<div className="space-y-2">
						<Label htmlFor="cancel-note">
							เหตุผล <span className="text-destructive">*</span>
						</Label>
						<Textarea
							id="cancel-note"
							placeholder="กรุณาระบุเหตุผลในการยกเลิก"
							value={note}
							onChange={(e) => setNote(e.target.value)}
							rows={3}
						/>
					</div>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={handleClose} disabled={isPending}>
						ปิด
					</Button>
					<Button
						variant="destructive"
						onClick={handleConfirm}
						disabled={!note.trim() || isPending}
					>
						{isPending ? 'กำลังยกเลิก...' : 'ยืนยันยกเลิก'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
